<template>
  <div class="">
    <navigation></navigation>
    <banner></banner>
    <div id="detail">
      <div class="container">
        <div class="main-detail">
          <div class="main-detail-container">
            <div class="detail-title">
              {{detail.newsname}}
            </div>
            <div class="detail-info">
              <img
                src="@/assets/imgs/time.png"
                class="time-icon"
                alt="发布时间"
              />
              <span class="text">{{detail.time}}</span>
              <img
                src="@/assets/imgs/view.png"
                class="view-icon"
                alt="浏览量"
              />
              <span class="text">{{detail.views}}</span>
            </div>
            <div class="content" v-html="detail.content">
            </div>
          </div>
        </div>
      </div>
    </div>
    <vfooter></vfooter>
  </div>
</template>
<script>
import navigation from "@/components/sub/Nav";
import vfooter from "@/components/sub/Footer";
import banner from "@/components/sub/Banner";
export default {
  name: "",
  components: {
    navigation,
    vfooter,
    banner,
  },
  data() {
    return {
      detail:{}
    };
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData() {
      this.axios
        .get(this.$host + "/api/news/detail?id="+this.$route.params.id)
        .then((res) => {
          this.detail = res.data.data;
          console.log(this.detail);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
  }
};
</script>
<style scoped>
#detail {
  position: flex;
  justify-content: space-between;
  width: 100%;
  background: #f7f8f9;
}

#detail .container {
  padding: 35px 0 27px 0;
  width: 1200px;
}

#detail .main-detail {
  width: 1200px;
  background-color: white;
}

#detail .main-detail .main-detail-container {
  padding: 51px 70px 38px 64px;
}

#detail .main-detail .detail-title {
  width: 100%;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: #333333;
  line-height: 30px;
}

#detail .main-detail .detail-info {
  width: 100%;
  padding-bottom: 19px;
  border-bottom: 1px solid #cccccc;
}

#detail .main-detail .time-icon {
  width: 19px;
  height: 19px;
  vertical-align: middle;
}

#detail .main-detail .view-icon {
  width: 21px;
  height: 14px;
  margin-left: 21px;
  vertical-align: middle;
}

#detail .main-detail .detail-info .text {
  height: 24px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

#detail .main-detail .content {
  padding: 41px 0 70px 0;
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 35px;
}

#detail .main-detail .content p {
  text-indent: 2rem;
}
#detail .main-detail .content img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/Detail.vue